/** 微信公众号 AppID */
export const WX_APPID = import.meta.env.VITE_WX_APPID || 'wxca2281cb35cb89e3'

/** 微信 OAuth 回调路径（需与公众号后台配置一致） */
export const WX_AUTH_CALLBACK_PATH = '/wx-callback'

/** OAuth 阶段标识 */
export const WX_OAUTH_PHASE = {
  BASE: 'base',
  USERINFO: 'userinfo',
}
